require('./cardStatementsTable.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
// @ components
const CardStatementsTableRow = require('components/cards/cardStatements/cardStatementsTableRow/cardStatementsTableRow');
// @ constants
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();

class CardStatementsTable extends React.Component {

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (!immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader={true}>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardsStatements-period" />
                        </OKTableCell>
                        <OKTableCell asHeader={true}>
                            <FormattedText value="cardsStatements-paymentMethod" />
                        </OKTableCell>
                        <OKTableCell asHeader={true} className="card-statements-table__cell-header-settlement">
                            <FormattedText value="cardsStatements-settlement" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    render() {
        const { immStatements, immStatementsByOrder } = this.props;
        const immStatementsById = immStatements.get('byId');
        const tableHead = this.buildTableHead();

        return (
            <LastMovementsTable
                groupByDate={false}
                rowComponent={CardStatementsTableRow}
                immTransactionsByOrder={immStatementsByOrder}
                immTransactionsById={immStatementsById}
                id={'card-statements'}
                currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                language={language}
            >
                {tableHead}
            </LastMovementsTable>
        );
    }
}

CardStatementsTable.propTypes = {
    immScreen: PropTypes.object.isRequired,
    immStatements: PropTypes.object.isRequired,
    immStatementsByOrder: PropTypes.object.isRequired,
};

module.exports = CardStatementsTable;
